/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!*************************************************!*\
  !*** ./resources/scripts/sections/faqs/main.js ***!
  \*************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "faqsSection": () => (/* binding */ faqsSection)
/* harmony export */ });
var faqsSection = function faqsSection() {
  var $faqsSections = document.querySelectorAll("section.faqs");
  if ($faqsSections) {
    $faqsSections.forEach(function ($faqSection) {
      var $faqs = $faqSection.querySelectorAll(".faqs__list .faq");
      $faqs.forEach(function ($faq) {
        var $faqQuestion = $faq.querySelector(".faq__question");
        $faqQuestion.addEventListener("click", function (event) {
          event.preventDefault();

          // Check if current FAQ is already open
          var $currentFaqAnswer = $faq.querySelector(".faq__answer");
          var isCurrentlyOpen = !$currentFaqAnswer.classList.contains("hidden");
          if (isCurrentlyOpen) {
            // If current FAQ is open, just close it
            var $currentFaqOpen = $faq.querySelector(".faq__question-icon .faq__question-icon-open");
            var $currentFaqClosed = $faq.querySelector(".faq__question-icon .faq__question-icon-closed");
            $currentFaqOpen.classList.add("hidden");
            $currentFaqClosed.classList.remove("hidden");
            $currentFaqAnswer.classList.add("hidden");
            $faq.classList.add("bg-cream-light");
          } else {
            // If current FAQ is closed, close all others and open this one
            $faqs.forEach(function ($faqInner) {
              var $faqIconOpen = $faqInner.querySelector(".faq__question-icon .faq__question-icon-open");
              var $faqIconClosed = $faqInner.querySelector(".faq__question-icon .faq__question-icon-closed");
              var $faqAnswer = $faqInner.querySelector(".faq__answer");
              $faqIconOpen.classList.add("hidden");
              $faqIconClosed.classList.remove("hidden");
              $faqAnswer.classList.add("hidden");
              $faqInner.classList.add("bg-cream-light");
            });

            // Open the current FAQ
            var _$currentFaqOpen = $faq.querySelector(".faq__question-icon .faq__question-icon-open");
            var _$currentFaqClosed = $faq.querySelector(".faq__question-icon .faq__question-icon-closed");
            _$currentFaqOpen.classList.remove("hidden");
            _$currentFaqClosed.classList.add("hidden");
            $currentFaqAnswer.classList.remove("hidden");
            $faq.classList.remove("bg-cream-light");
          }
        });
      });
    });
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (faqsSection);
document.addEventListener("DOMContentLoaded", faqsSection);
/******/ })()
;